// extracted by mini-css-extract-plugin
export default {"form":"Form_form__vAage","heading":"Form_heading__D977I","field":"Form_field__iz+xj","input":"Form_input__nAPcB","btn":"Form_btn__j6l3v","footer":"Form_footer__P2H69"};